"use client";

import {
	createContext,
	type PropsWithChildren,
	useContext,
	useMemo,
	useState,
} from "react";

interface MarketingHomeScrollPendingContextValue {
	pendingLandingSectionId: string | null;
	setPendingLandingSectionId: (id: string | null) => void;
}

const MarketingHomeScrollPendingContext =
	createContext<MarketingHomeScrollPendingContextValue | null>(null);

export function MarketingHomeScrollPendingProvider({
	children,
}: PropsWithChildren) {
	const [pendingLandingSectionId, setPendingLandingSectionId] = useState<
		string | null
	>(null);
	const value = useMemo(
		() => ({ pendingLandingSectionId, setPendingLandingSectionId }),
		[pendingLandingSectionId],
	);
	return (
		<MarketingHomeScrollPendingContext.Provider value={value}>
			{children}
		</MarketingHomeScrollPendingContext.Provider>
	);
}

export function useMarketingHomeScrollPending(): MarketingHomeScrollPendingContextValue {
	const ctx = useContext(MarketingHomeScrollPendingContext);
	if (ctx == null) {
		throw new Error(
			"useMarketingHomeScrollPending requires MarketingHomeScrollPendingProvider",
		);
	}
	return ctx;
}
